import { createContext, useState, useContext, FC } from 'react';
import { noop } from 'lodash';
// Import Types
import type { SelectedObjectDetails, Version, VersionHistoryContextValues } from './types';

const VersionHistoryContext = createContext<VersionHistoryContextValues>({
    selectedHistoryVersion: null,
    setSelectedHistoryVersion: noop,
    selectedObjectDetails: null,
    setSelectedObjectDetails: noop,
    pointInTime: null,
    isHistoryMode: false,
});

export const VersionHistoryProvider: FC = ({ children }) => {
    const [selectedHistoryVersion, setSelectedHistoryVersion] = useState<Version | null>(null);
    const [selectedObjectDetails, setSelectedObjectDetails] = useState<SelectedObjectDetails | null>(null);
    const pointInTime = selectedHistoryVersion?.PointInTime ?? null;
    const isHistoryMode = !!selectedHistoryVersion;

    return (
        <VersionHistoryContext.Provider
            value={{
                selectedHistoryVersion,
                selectedObjectDetails,
                setSelectedHistoryVersion,
                setSelectedObjectDetails,
                pointInTime,
                isHistoryMode,
            }}
        >
            {children}
        </VersionHistoryContext.Provider>
    );
};

export const useVersionHistoryContext = () => {
    return useContext(VersionHistoryContext);
};
